import React, { useState, useEffect } from 'react';
import MainPlatform from './MainPlatform';
import LandingPage from './LandingPage';
import PublicLanguageDock from './components/PublicLanguageDock';
import { ROUTES, navigateTo } from './domainConfig';
import { useTranslation } from './i18n';

const CANDIDATE_API = process.env.REACT_APP_CANDIDATE_API || 'http://127.0.0.1:8002';
const BASE_TITLE = process.env.REACT_APP_SEO_TITLE || 'Betaaldsolliciteren.nl - Niet beloven. Bewijzen.';

export default function AppKandidaat() {
  const [path, setPath] = useState(window.location.pathname);
  const { t, language } = useTranslation();

  const normalizePath = (target) => {
    try {
      return new URL(target, window.location.origin).pathname;
    } catch (_) {
      return String(target || '/').split('?')[0].split('#')[0] || '/';
    }
  };

  useEffect(() => {
    const onPopState = () => setPath(window.location.pathname);
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  // Houd de browser-tab-titel synchroon met de huidige route.
  useEffect(() => {
    if (path.startsWith(ROUTES.kandidaatPortaal)) {
      document.title = t('route_titles.talent');
    } else {
      document.title = t('route_titles.root') || BASE_TITLE;
    }
  }, [path, t, language]);

  const navigate = (newPath) => {
    window.history.pushState({}, "", newPath);
    setPath(normalizePath(newPath));
  };

  // Cross-domain navigatie helper
  const handleNavigate = (targetPath) => {
    navigateTo(targetPath, navigate);
  };

  // Kandidaat portaal
  if (path.startsWith(ROUTES.kandidaatPortaal)) {
    return (
      <MainPlatform 
        userType="candidate" 
        apiBase={CANDIDATE_API} 
        onLogout={() => navigate('/')}
        onBackToHome={() => navigate('/')} 
      />
    );
  }

  // Landing page (root)
  return (
    <>
      <PublicLanguageDock />
      <LandingPage onNavigate={handleNavigate} />
    </>
  );
}
